import React from 'react'

import Modal from './Modal'
import modalVisibility from './modalVisibility'


export default modalVisibility('common', Modal)
